import { match } from 'ts-pattern'

import { automationsPaths } from 'Automations/router'
import { useCurrentListView } from './useCurrentListView'

/**
 * The inbox list route for the current view. On mobile this is the "back"
 * target from a detail/preview — navigating to it clears the selected-item
 * param, so the single-pane layout falls back to showing the list.
 */
export const useWatchtowerListPath = (): string => {
  const { currentView } = useCurrentListView()

  return match(currentView)
    .with('all', () => automationsPaths.executionInbox())
    .with('needsAction', () => `${automationsPaths.manualTasksInbox()}/tasks`)
    .exhaustive()
}
